(function () {
  function initPanel(panel) {
    var root = panel.closest('article.info') || panel.parentElement;
    if (!root) return;
    var bar = root.querySelector('[data-lb-bw-scrollbar]');
    var hint = root.querySelector('[data-lb-bw-hint]');
    if (!bar) return;
    var track = bar.querySelector('.lb-bw-scrollbar__track');
    var thumb = bar.querySelector('.lb-bw-scrollbar__thumb');
    if (!track || !thumb) return;

    function sync() {
      var scrollHeight = panel.scrollHeight;
      var clientHeight = panel.clientHeight;
      var scrollTop = panel.scrollTop;

      if (scrollHeight <= clientHeight + 1) {
        bar.classList.add('is-hidden');
        if (hint) hint.classList.add('is-hidden');
        return;
      }

      bar.classList.remove('is-hidden');
      var trackHeight = track.clientHeight;
      var thumbHeight = Math.max(56, Math.round((clientHeight / scrollHeight) * trackHeight));
      var maxOffset = Math.max(0, trackHeight - thumbHeight);
      var offset = maxOffset ? (scrollTop / (scrollHeight - clientHeight)) * maxOffset : 0;

      thumb.style.height = thumbHeight + 'px';
      thumb.style.transform = 'translateY(' + offset + 'px)';

      if (hint) {
        hint.classList.toggle('is-hidden', scrollTop > 24 || scrollTop >= scrollHeight - clientHeight - 24);
      }
    }

    panel.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync);
    }
    sync();
    setTimeout(sync, 150);
    setTimeout(sync, 900);
  }

  function init() {
    var panels = document.querySelectorAll('.lb-bw-scroll-panel');
    for (var i = 0; i < panels.length; i++) {
      initPanel(panels[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
